module.exports = __webpack_public_path__ + "media/images/ic_frais-7733a69e.svg";